import { FilterConfigType } from "../../../../../kernel/listing/filter/interfaces/filters-config-interface";
import { filterOptions } from "../../../../../kernel/listing/filter/enums/filter-options";
import { FilterInputTypeEnum } from "../../../../../kernel/listing/filter/enums/filter-input-type.enum";

export const filterStockTypeConfig = (): FilterConfigType[] => [
  {
    field: "name",
    label: "STOCK_TYPE.COMMON.NAME",
    options: [filterOptions.LIKE, filterOptions.IS],
    type: FilterInputTypeEnum.TEXT,
    placeHolder: "STOCK_TYPE.COMMON.NAME",
  },
  {
    field: "code",
    label: "STOCK_TYPE.COMMON.CODE",
    options: [filterOptions.LIKE, filterOptions.IS],
    type: FilterInputTypeEnum.TEXT,
    placeHolder: "STOCK_TYPE.COMMON.CODE",
  },
  {
    field: "description",
    label: "STOCK_TYPE.COMMON.DESCRIPTION",
    options: [filterOptions.LIKE, filterOptions.IS],
    type: FilterInputTypeEnum.TEXT,
    placeHolder: "STOCK_TYPE.COMMON.DESCRIPTION",
  },
  {
    field: "enabled",
    label: "COMMON.STATUS",
    options: [filterOptions.IS],
    type: FilterInputTypeEnum.AUTOCOMPLETE_SELECT,
    optionLabel: "label",
    optionValue: "value",
    placeHolder: "COMMON.ENABLED",
    search: [
      {
        label: "COMMON.ENABLED",
        value: "true",
      },
      {
        label: "COMMON.DISABLED",
        value: "false",
      },
    ],
  },
  {
    field: "createdAt",
    label: "COMMON.CREATED_AT",
    options: [filterOptions.IS, filterOptions.LESS_THAN, filterOptions.GREATER_THAN],
    type: FilterInputTypeEnum.DATE,
    placeHolder: "COMMON.CREATED_AT",
  },
  {
    field: "updatedAt",
    label: "COMMON.UPDATED_AT",
    options: [filterOptions.IS, filterOptions.LESS_THAN, filterOptions.GREATER_THAN],
    type: FilterInputTypeEnum.DATE,
    placeHolder: "COMMON.UPDATED_AT",
  },
];
